import * as React from "react";

import { NativeConicGradientViewProps } from "./NativeConicGradient.types";

export default function ConicGradientView(props: NativeConicGradientViewProps) {
  return <div />;
}
